import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import logoBinargon from '@/assets/logos/integration/binargon.png';
import logoDrupal from '@/assets/logos/integration/drupal.png';
import logoFastcentrik from '@/assets/logos/integration/fastcentrik.png';
import logoComgate from '@/assets/logos/integration/comgate.svg';
import logoEbrana from '@/assets/logos/integration/ebrana.png';
import logoItStudio from '@/assets/logos/integration/it-studio.svg';
import logoJzShop from '@/assets/logos/integration/jzshop.svg';
import logoMagento from '@/assets/logos/integration/magento.svg';
import logoOpencart from '@/assets/logos/integration/opencart.png';
import logoPrestashop from '@/assets/logos/integration/prestashop.svg';
import logoRetailys from '@/assets/logos/integration/retailys.svg';
import logoShopfy from '@/assets/logos/integration/shopfy.svg';
import logoShoptet from '@/assets/logos/integration/shoptet.svg';
import logoShoptetPremium from '@/assets/logos/integration/shoptet-premium.svg';
import logoTheshop from '@/assets/logos/integration/theshop.jpeg';
import logoTrustpay from '@/assets/logos/integration/trustpay.png';
import logoVirtuemart from '@/assets/logos/integration/virtuemart.png';
import logoWoocommerce from '@/assets/logos/integration/woocommerce.svg';
import logoSimplia from '@/assets/logos/integration/simplia.svg';
import logoGoPay from '@/assets/logos/integration/goPay.svg';
import logoCsob from '@/assets/logos/csob-dark.svg';
import { Button } from '@/components/buttons';
import { SectionHeadline } from '@/components/SectionHeadline';
import { EXTERNAL_LINKS } from '@/constants/links';
import { SourceList } from '@/sections/forEshops/SourceList';
import { DXHeroesBubble } from '@/sections/forEshops/DXHeroesBubble';
import EshopBoxes from '@/components/boxes/EshopBox/EshopBoxes';
import { EshopBox, SvgComponent } from '@/components/boxes/EshopBox/types';
import { Text } from '@/components/typography';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
const standardSolitinList = [{
  title: 'IT Studio',
  link: 'https://www.itstudio.cz/',
  logo: logoItStudio
}, {
  title: 'Shopty.',
  link: 'https://www.shopty.cz/',
  logo: logoShopfy
}, {
  title: 'eBrana',
  link: 'https://ebrana.cz/',
  logo: logoEbrana
}, {
  title: 'Fastcentrik',
  link: 'https://www.fastcentrik.cz/podpora/tipy-a-triky/mall-pay-platebni-brana-s-odlozenou-platbou',
  logo: logoFastcentrik
}, {
  title: 'Shoptet premium',
  link: 'https://doplnky.shoptet.cz/skip-pay-premium',
  logo: logoShoptetPremium
}, {
  title: 'Shoptet',
  link: 'https://doplnky.shoptet.cz/skip-pay',
  logo: logoShoptet
}, {
  title: 'Retailys',
  link: 'https://www.retailys.cz/',
  logo: logoRetailys
}, {
  title: 'JZ shop',
  link: 'https://www.jzshop.cz/',
  logo: logoJzShop
}, {
  title: 'Binargon',
  link: 'https://www.binargon.cz/',
  logo: logoBinargon
}];
const standardSolitinListHU = [{
  title: 'Simplia',
  link: 'https://www.simplia.cz/',
  logo: logoSimplia
}];
const gateList = (isCs: boolean) => {
  return [{
    title: 'ČSOB',
    link: 'https://github.com/csob/paymentgateway/wiki',
    logo: logoCsob
  }, {
    title: 'Comgate',
    link: 'https://help.comgate.cz/docs/odlozena-platba#skip-pay-d%C5%99%C3%ADve-mallpay',
    logo: logoComgate
  }, {
    title: 'TrustPay',
    link: isCs ? 'https://www.trustpay.cz/' : 'https://www.trustpay.sk',
    logo: logoTrustpay
  }, {
    title: 'GoPay',
    link: isCs ? 'https://www.gopay.com/cs/' : 'https://www.gopay.com/sk/',
    logo: logoGoPay
  }];
};
const opensourceList = [{
  title: 'PrestaShop',
  link: 'https://www.platiti.cz/PrestaShop-MallPay.php',
  logo: logoPrestashop
}, {
  title: 'WooCommerce',
  link: 'https://www.platiti.cz/WooCommerce-MallPay.php',
  logo: logoWoocommerce
}, {
  title: 'OpenCart',
  link: 'https://www.platiti.cz/OpenCart-MallPay.php',
  logo: logoOpencart
}, {
  title: 'Drupal commerce',
  link: 'https://www.platiti.cz/DrupalCom-MallPay.php',
  logo: logoDrupal
}, {
  title: 'Virtuemart',
  link: 'https://www.platiti.cz/Virtuemart-MallPay.php',
  logo: logoVirtuemart
}, {
  title: 'Magento',
  link: 'https://www.platiti.cz/Magento-MallPay.php',
  logo: logoMagento
}, {
  title: 'TheShop',
  link: 'https://www.theshop.managemen',
  logo: logoTheshop
}];
const opensourceListHu = [{
  title: 'PrestaShop',
  link: 'https://www.platiti.cz/PrestaShop-MallPay.php',
  logo: logoPrestashop
}, {
  title: 'WooCommerce',
  link: 'https://www.platiti.cz/WooCommerce-MallPay.php',
  logo: logoWoocommerce
}, {
  title: 'OpenCart',
  link: 'https://www.platiti.cz/OpenCart-MallPay.php',
  logo: logoOpencart
}, {
  title: 'Drupal commerce',
  link: 'https://www.platiti.cz/DrupalCom-MallPay.php',
  logo: logoDrupal
}, {
  title: 'Virtuemart',
  link: 'https://www.platiti.cz/Virtuemart-MallPay.php',
  logo: logoVirtuemart
}, {
  title: 'Magento',
  link: 'https://www.platiti.cz/Magento-MallPay.php',
  logo: logoMagento
}];
export function convertList(items: {
  title: string;
  link: string;
  logo: string | SvgComponent;
}[]): EshopBox[] {
  return items.map(({
    title,
    link,
    logo
  }, index) => {
    return {
      link,
      image: {
        size: 'contain',
        title,
        url: logo,
        width: 160,
        height: 60
      },
      size: 'sm',
      index,
      section: 'forEshops'
    };
  });
}
export function Integration(t0) {
  const $ = _c(54);
  const {
    children,
    showBubble
  } = t0;
  const {
    t
  } = useTranslation("forEshops");
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t1;
  if ($[0] !== showBubble) {
    t1 = showBubble && <DXHeroesBubble />;
    $[0] = showBubble;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("integration.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SectionHeadline className="mb-5 px-0" anchorKey="integration.title">{t2}</SectionHeadline>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("integration.text");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Text variant="p2" className="text-center text-gray-800">{t4}</Text>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = EXTERNAL_LINKS();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = t6.developersPortalGuides;
  let t8;
  if ($[11] !== t) {
    t8 = t("integration.cta");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <Button to={t7} testId="forEshopsForDevelopers" analyticsParam="forEshopsForDevelopers" size="lg" variant="primary" align="center" className="mt-10 lg:mt-12">{t8}</Button>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5 || $[18] !== t9) {
    t10 = <div className="relative mx-auto max-w-192">{t1}{t3}{t5}{t9}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("integration.solutions.1.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("integration.solutions.1.text");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = isHuLanguage ? standardSolitinListHU : standardSolitinList;
  let t14;
  if ($[24] !== t13) {
    t14 = convertList(t13);
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <EshopBoxes eshops={t14} boxSize="sm" />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t15) {
    t16 = <SourceList title={t11} anchorKey="integration.solutions.1.title" text={t12} items={t15} />;
    $[28] = t11;
    $[29] = t12;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== isCsLanguage || $[33] !== isHuLanguage || $[34] !== t) {
    t17 = !isHuLanguage && <SourceList title={t("integration.solutions.2.title")} anchorKey="integration.solutions.2.title" text={t("integration.solutions.2.text")} items={<EshopBoxes eshops={convertList(gateList(isCsLanguage))} boxSize="sm" />} />;
    $[32] = isCsLanguage;
    $[33] = isHuLanguage;
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("integration.solutions.3.title");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("integration.solutions.3.text");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  const t20 = isHuLanguage ? opensourceListHu : opensourceList;
  let t21;
  if ($[40] !== t20) {
    t21 = convertList(t20);
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21) {
    t22 = <EshopBoxes eshops={t21} boxSize="sm" />;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t18 || $[45] !== t19 || $[46] !== t22) {
    t23 = <SourceList title={t18} anchorKey="integration.solutions.3.title" text={t19} items={t22} />;
    $[44] = t18;
    $[45] = t19;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== children || $[49] !== t10 || $[50] !== t16 || $[51] !== t17 || $[52] !== t23) {
    t24 = <div className="flex flex-col gap-20 lg:gap-24">{t10}{children}{t16}{t17}{t23}</div>;
    $[48] = children;
    $[49] = t10;
    $[50] = t16;
    $[51] = t17;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  return t24;
}